export default __webpack_public_path__ + "svgs/closeLargeCircle-dd718ad0.svg";